module.exports = __webpack_public_path__ + "img/plus.f7e106b4.svg";